export default "__VITE_ASSET__BzcJVlxm__"